import { Box } from "@mui/material"
import EmployeeInfo from "../employeeInfo/employeeInfoCM"

export const ShareEmployeeProfile=()=>{
    return <Box>
        <EmployeeInfo         config={{personalInfo:true}}/>
    </Box>
}